import { load } from 'cheerio';
import Provider from '@/enums/Provider';
import IImage from '@/interfaces/IImage';
import UrlTypes from '@/enums/UrlTypes';
import { useNotificationStore } from '@/store/notificationStore';

export function extractCategoryImage(
    htmlSource: string,
    pathname: string,
    provider: Provider
): IImage[] {
    const notificationStore = useNotificationStore();
    const $ = load(htmlSource);
    const categoryImages: IImage[] = [];

    switch (provider) {
        case Provider.KBS: {
            break;
        }
        case Provider.IO: {
            // Check if htmlSource is empty
            if (!htmlSource || htmlSource.length === 0) {
                notificationStore.addWarningNotification('Category Hub Source is empty when processing category: ' + pathname);
            }
            // Find the first anchor whose href contains the pathname and then get its image (with class "cat_img")
            const imageElement = $(`a[href*="${pathname}"] img.cat_img`).first();
            if (imageElement.length > 0) {
                const src = imageElement.attr('src') || '';
                const alt = imageElement.attr('alt') || imageElement.attr('title') || '';
                if (src) {
                    categoryImages.push({
                        parentPathname: pathname,
                        src,
                        alt,
                        type: UrlTypes.CATEGORY
                    });
                }
            }
            break;
        }
        case Provider.ERS:
            // Check if htmlSource is empty
            if (!htmlSource || htmlSource.length === 0) {
                notificationStore.addWarningNotification('Category Hub Source is empty when processing category: ' + pathname);
            }
            // Find the panel-body div that has an onclick attribute matching the pathname
            $(`.panel-body[onclick*="${pathname}"] img`).each((i, img) => {
                const src = $(img).attr('src');
                const alt = $(img).attr('alt') || $(img).attr('title') || '';
                if (src) {
                    categoryImages.push({
                        parentPathname: pathname,
                        src: src,
                        alt,
                        type: UrlTypes.CATEGORY
                    });
                }
            });
            // If no images were found the old way, look for the new pattern
            // i.e., a DIV (like id="category_panel_123") that has an onclick to our category
            // and a style attribute with a background url(...)
            if (categoryImages.length === 0) {
                const panelDiv = $(`[onclick*="${pathname}"][id^="category_panel_"]`);
                if (panelDiv.length > 0) {
                    panelDiv.each((_, el) => {
                        const $div = $(el);
                        const styleAttr = $div.attr('style') || '';
                        // e.g.: background: white url("//files.sysers.com/...") no-repeat;
                        const match = styleAttr.match(/url\("(.*?)"\)/);
                        if (match && match[1]) {
                            const src = match[1];
                            // Try to use the sibling/parent h3 text as alt
                            // (You can change this selector if you want some other text.)
                            const alt =
                                $div
                                    .closest('.col-md-4')
                                    .find('h3.panel-title')
                                    .text()
                                    .trim() || '';
                            categoryImages.push({
                                parentPathname: pathname,
                                src,
                                alt,
                                type: UrlTypes.CATEGORY,
                            });
                        }
                    });
                }
            }

            // Third fallback: Look for any images in the category path structure
            // Some ERS sites use simple img tags without onclick handlers
            if (categoryImages.length === 0) {
                $('img[src*="categories/"]').each((i, img) => {
                    const src = $(img).attr('src');
                    const alt = $(img).attr('alt') || $(img).attr('title') || '';

                    // Only include ERS-specific images (files.sysers.com or relative paths)
                    if (src && (src.includes('files.sysers.com') || (!src.startsWith('http') && !src.startsWith('//')))) {
                        categoryImages.push({
                            parentPathname: pathname,
                            src,
                            alt,
                            type: UrlTypes.CATEGORY
                        });
                    }
                });
            }
            break;
        default:
            break;
    }
    return Array.from(categoryImages);
}